import { render, staticRenderFns } from "./BCT.vue?vue&type=template&id=85a27a84"
import script from "./BCT.vue?vue&type=script&lang=js"
export * from "./BCT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports